export interface ReviewPacketSummary {
  total: number
  checked: number
  ready: number
  differences: number
  missing: number
  document_id: string
}

export const reviewMessageActionCard = (summary: ReviewPacketSummary) => ({
  title: `${summary.checked === summary.total ? 'Все накладные проверены' : 'Накладные готовы к проверке'} · ${summary.total}`,
  description: summary.checked === summary.total
    ? 'Все накладные этого разбора проверены. Результат сохранён в общем списке.'
    : 'Откройте накладные, проверьте данные и подтвердите результат.',
  progress: { completed: summary.checked, total: summary.total },
  badges: [
    summary.ready ? { label: `Без расхождений · ${summary.ready}`, tone: 'success' } : null,
    summary.differences ? { label: `Требует проверки · ${summary.differences}`, tone: 'warning' } : null,
    summary.missing ? { label: `Нужно сопоставить · ${summary.missing}`, tone: 'warning' } : null,
    summary.checked ? { label: `Проверено · ${summary.checked}`, tone: 'default' } : null,
  ].filter(Boolean),
  action: { id: 'review-documents', label: summary.checked === summary.total ? 'Открыть результат' : 'Проверить накладные' },
})
